<template>
  <div>
    <h1 class="header-title">Vous pouvez fermer cette page</h1>
  </div>
</template>

<script>

export default {
  name: "Fermer",
  beforeMount() {
    this.$root.$refs.breadcrumbComp.source.nom = 'fermer';
    this.$root.$refs.breadcrumbComp.source.genre = '';
    this.$root.$refs.breadcrumbComp.source.module = ''
  },
}
</script>
